import { useAxios } from 'packages/core'
import { useQuery } from '@tanstack/react-query'

export const useCommonGetAPI = (url) => {
    const callApi = useAxios()
    return useQuery(
        ['COMMON_GET_API', url],
        () =>
            callApi({
                method: 'GET',
                url: url,
            }).then((data) => data),
        {
            enabled: Boolean(url),
        },
    )
}
